import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Travel } from '../models/travel';
import { Paysheet } from '../models/paysheet';

export class PaysheetResult {
  operator:number = 0;
  helper:number = 0;
  type:string = 'TON';
  base:number = 0;
}

@Injectable({
  providedIn: 'root'
})
export class PaysheetService {

  constructor(private http:HttpClient) { }

  getPaysheets() : Promise<Paysheet[]> {
    return this.http.get<Paysheet[]>('/api/paysheet')
      .toPromise();
  }

  postPaysheet(paysheet:Paysheet) : Promise<Paysheet> {
    return this.http.post<Paysheet>('/api/paysheet', paysheet)
      .toPromise();
  }

  getPaysheet(id:Number) : Promise<Paysheet> {
    return this.http.get<Paysheet>('/api/paysheet/' + id)
      .toPromise();
  }
  
  putPaysheet(paysheet:Paysheet) : Promise<Paysheet> {
    return this.http.post<Paysheet>('/api/paysheet/' + paysheet.id + '/edit', paysheet)
      .toPromise();
  }
  
  deletePaysheet(paysheet:Paysheet) : Promise<void> {
    return this.http.get<void>('/api/paysheet/' + paysheet.id + '/delete')
      .toPromise();
  }

  calculatePaysheet(travel_id:number, date:Date) : Promise<PaysheetResult> {
    return this.http.get<PaysheetResult>('/api/paysheet/calculate/' + travel_id, {params: {date: date.toString()}})
      .toPromise();
  }
}
